<template>
  <div
    id="setting"
    class="position-absolute"
    :style="{ top: top + 'px', left: left + 'px', height: '190px' }"
    v-if="visible"
  >
    <div class="w-full h-full figures-set-card">
      <p class="w-full setting-text-lable fz-16 m-t-25px">是否恢复本地视角</p>
      <div class="w-full m-t-40px flex flex-align-center submit-button justify-content-center">
        <el-button type="primary" size="mini" @click="restoreView" :loading="saveLoading"
          >恢复本地视角</el-button
        >
        <el-button size="mini" @click="useDefaultView" :loading="saveLoading"
          >使用默认视角</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LocalForageView',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      saveLoading: false,
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    // 绝对定位布局屏幕正中
    top() {
      return (window.innerHeight - 190) / 2
    },
    left() {
      return (window.innerWidth - 368) / 2
    },
  },
  created() {},
  beforeDestroy() {},
  methods: {
    restoreView() {
      this.saveLoading = true
      this.saveLoading = false
      this.$emit('update:visible', false)
      this.$emit('restoreLocalView')
    },
    useDefaultView() {
      this.saveLoading = true
      this.$emit('restoreDefaultView')
      setTimeout(() => {
        this.saveLoading = false
        this.$emit('update:visible', false)
      }, 1000)
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../css/index.scss';
#setting {
  width: 368px;
  background-color: #1b4555 !important;
  z-index: 999;
  .figures-set-card {
    padding: 24px;
    background-color: #1a5da3 !important;
  }
}
.m-t-25px {
  margin: 25px 0 0 0 !important;
}
.m-t-40px {
  margin: 40px 0 0 0 !important;
}
.flex {
  display: flex;
}
.flex-align-center {
  text-align: center;
}
.position-absolute {
  position: absolute !important;
}
.justify-content-center {
  justify-content: center;
}
.submit-button {
  justify-content: space-around;
}
.select-option-item {
  width: 15px;
  height: 15px;
}
.setting-text-lable {
  text-align: center;
  color: #ffffff;
}
/deep/.el-tabs__nav-wrap::after {
  height: 1px !important;
  background-color: #00c0ff;
}
/deep/ .el-tabs__content {
  height: calc(100% - 70px);
  .el-tab-pane {
    height: 100%;
    overflow-y: auto;
  }
}
.color-input /deep/.el-input__inner,
.keystroke-set /deep/.el-input__inner {
  text-align: center;
}
// switch相关
/deep/.el-switch {
  &__core {
    border-color: $danger !important;
    background-color: $danger !important;
  }
}
/deep/ .el-input-number.is-controls-right .el-input__inner {
  padding-right: 30px !important;
}
/deep/.el-switch.is-checked {
  .el-switch__core {
    border-color: $success !important;
    background-color: $success !important;
  }
}
/deep/ .el-input-number.is-controls-right .el-input-number__decrease,
/deep/ .el-input-number.is-controls-right .el-input-number__increase {
  border: none !important;
}

</style>
